import React from "react";
import { Grid, TextField } from "@material-ui/core";

function MinAndMaxLength({
  values,
  valuesPath = "",
  handleChange,
  setFieldValue,
  isOnlyFormattingConfig,
  isAdditionalOptions,
}) {
  const { options: { min_length: minLength = "", max_length: maxLength = "", default_value: defaultValue = "" } = {} } = values || {};
  React.useEffect(() => {
    if (minLength !== "" || isOnlyFormattingConfig) {
      return;
    }
    setFieldValue(`${valuesPath}options.min_length`, 0);
    setFieldValue(`${valuesPath}options.max_length`, 100);
  }, [setFieldValue, minLength, valuesPath, isOnlyFormattingConfig]);

  if (isOnlyFormattingConfig || !isAdditionalOptions) {
    return null;
  }

  const defaultType = values && values.column_type_id == 5 ? "number" : "text";

  return (
    <React.Fragment>
      <Grid item container>
        <Grid item xs={6}>
          Max Length:
        </Grid>
        <TextField
          variant="outlined"
          name={`${valuesPath}options.max_length`}
          value={maxLength}
          onChange={handleChange}
          size="small"
          style={{ maxWidth: 50 }}
          type="number"
          inputProps={{
            min: "0",
          }}
          onInput={(event) => {
            event.target.value =
              !isNaN(Number(event.target.value)) && event.target.value >= 0
                ? event.target.value
                : "";
          }}
        />
      </Grid>
      <Grid item container>
        <Grid item xs={6}>
          Min Length:
        </Grid>
        <TextField
          variant="outlined"
          name={`${valuesPath}options.min_length`}
          value={minLength}
          onChange={handleChange}
          size="small"
          style={{ maxWidth: 50 }}
          type="number"
          inputProps={{
            min: "0",
          }}
          onInput={(event) => {
            event.target.value =
              !isNaN(Number(event.target.value)) && event.target.value >= 0
                ? event.target.value
                : "";
          }}
        />
      </Grid>
      {values && (values.column_type_id == 1 || values.column_type_id == 5) && (
        <Grid item container>
          <Grid item xs={6}>
            Default Value
          </Grid>
          <TextField
            variant="outlined"
            name={`${valuesPath}options.default_value`}
            value={defaultValue}
            onChange={handleChange}
            size="small"
            type={defaultType}
          />
        </Grid>
      )}
    </React.Fragment>
  );
}

export default MinAndMaxLength;
